import {DtoMapper} from '@wemogy/reactbase';
import {ICustomer} from '../../models/Customer';

export default class CustomerDtoMapper extends DtoMapper<ICustomer, any>{

}
